import React, { useState } from 'react';
import { AxiosError } from 'axios';
import { Button } from '@fiverr-private/button';
import { logger } from '@fiverr-private/obs';
import { upgradeToAdvanced } from '../../api/upgradeToAdvanced';
import { clickSubscriptionEvent } from '../../events/subscriptionEvent';
import { ADVANCED_PLAN_TYPE, ESSENTIAL_PLAN_TYPE } from '../../types/plan';
import { raiseGeneralErrorToast } from '../../toasts';

export interface UpgradeToAdvancedPlanButtonProps {
    children: React.ReactNode;
    fullWidth?: boolean;
    biData?: {
        pageName?: string;
        sellerId?: number;
        upgradeSource?: string;
    };
    redirectUrl?: string;
}

export const UpgradeToAdvancedPlanButton = ({
    children,
    biData,
    fullWidth = true,
    redirectUrl,
}: UpgradeToAdvancedPlanButtonProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const onUpgradeToAdvanced = async () => {
        clickSubscriptionEvent({
            eventType: 'clicked_pro_subscription_advanced_plan_upgrade',
            componentName: 'pro_subscription_advanced_plan_upgrade',
            currentPlan: ESSENTIAL_PLAN_TYPE,
            componentType: 'BUTTON',
            ...biData,
            pageName: biData?.pageName || '',
        });
        setIsLoading(true);

        try {
            const { paymentUrl } = await upgradeToAdvanced(redirectUrl);

            window.location.href = paymentUrl;
        } catch (error) {
            // We don't want to set loading to false in case of success
            // because we're gonna redirect to the payment page
            setIsLoading(false);
            raiseGeneralErrorToast();

            if (!(error instanceof AxiosError)) {
                logger.error(error as Error, {
                    description: 'Failed to upgrade to advanced',
                    targetPackage: ADVANCED_PLAN_TYPE,
                    currentPackage: ESSENTIAL_PLAN_TYPE,
                });
            }
        }
    };

    return (
        <Button
            fullWidth={fullWidth}
            variant="filled"
            intent="primary"
            disabled={isLoading}
            loading={isLoading}
            onClick={onUpgradeToAdvanced}
        >
            {children}
        </Button>
    );
};
